



import React, { useState, useEffect } from "react";
import { MetricCard } from "./MetricCard";
import "./ReportAnalysisTab.css";
import { FaRupeeSign, FaShoppingCart, FaStar } from "react-icons/fa";
import { MdTrendingUp, MdTrendingDown } from "react-icons/md";
import { BiWallet } from "react-icons/bi";
import InsightsChartSection from "./InsightsChartSection";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts";
import {
    getAdminStatistics,
    getPast7DaysTrend
} from "../../../Servicefile/ReportAnalysisService.jsx";

function pct(curr, prev) {
    if (!prev || prev === 0) return 0;
    return ((curr - prev) / prev) * 100;
}

function FoodOverviewTab({ data: propData, isLoading: propLoading }) {
    const [data, setData] = useState(propData || null);
    const [loading, setLoading] = useState(!propData);
    const [error, setError] = useState(null);
    const vendorId = localStorage.getItem("vendorId");

    // Add this state at the top with other states
    const [trendData, setTrendData] = useState(null);
    const [trendLoading, setTrendLoading] = useState(false);


    const pieChartData =
        data?.topPerformingVendors?.map(
            (vendor) => ({
                name: `Vendor ${vendor.vendorId}`,
                value: vendor.revenue,
            })
        ) || [];

    const COLORS = [
        "#2563eb",
        "#16a34a",
        "#f59e0b",
        "#dc2626",
        "#9333ea",
    ];
    // Add this useEffect to fetch past 7 days data (independent of filters)
    useEffect(() => {
        fetchPast7DaysData();
    }, [vendorId]);

    // Update data when propData changes (from filters)
    useEffect(() => {
        if (propData) {
            setData(propData);
            setLoading(false);
            setError(null);
        }
    }, [propData]);

    // Fetch data only if no propData is provided
    useEffect(() => {
        if (!propData) {
            fetchData();
        }
    }, [vendorId, propData]);

    const formatChartData = () => {

        if (!trendData?.allVendors)
            return [];

        return trendData.allVendors
            .slice(0, 7)
            .map((vendor) => ({

                day: `V-${vendor.vendorId}`,

                orders:
                    vendor.todayOrders || 0,

                revenue:
                    vendor.todayRevenue || 0,
            }));
    };


    // Add this function to fetch past 7 days data
    const fetchPast7DaysData =
        async () => {

            try {

                setTrendLoading(true);

                const result =
                    await getPast7DaysTrend();

                console.log(
                    "Trend Data:",
                    result
                );

                setTrendData(result);

            } catch (err) {

                console.error(
                    "Error fetching trend data:",
                    err
                );

            } finally {

                setTrendLoading(false);
            }
        };
    const fetchData = async () => {

        try {

            setLoading(true);

            setError(null);

            const result =
                await getAdminStatistics();

            console.log(
                "Admin Statistics:",
                result
            );

            setData(result);

        } catch (err) {

            console.error(
                "Fetch Error:",
                err
            );

            if (
                err.message ===
                "NO_AUTH_TOKEN"
            ) {

                setError(
                    "Unable to load data. Please log in again."
                );

            } else if (
                err.message ===
                "SESSION_EXPIRED"
            ) {

                setError(
                    "Your session has expired. Please log in again to continue."
                );

            } else if (
                err.message ===
                "DATA_NOT_FOUND"
            ) {

                setError(
                    "Data not found."
                );

            } else {

                setError(
                    "Please try again later."
                );
            }

        } finally {

            setLoading(false);
        }
    };

    // Retry handler
    const handleRetry = () => {
        setLoading(true);
        setError(null);
        fetchData();
    };

    // Use propLoading if provided, otherwise use local loading state
    const isLoading = propLoading !== undefined ? propLoading : loading;

    if (isLoading) {
        return (
            <div className="tab-content flex justify-center items-center h-64">
                <div className="text-center">
                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-4"></div>
                    <p className="text-muted-foreground">Loading your dashboard...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="tab-content flex justify-center items-center h-64">
                <div className="text-center text-negative">
                    <p className="font-semibold mb-2">Unable to Load Data</p>
                    <p className="text-sm mb-4">{error}</p>
                    {/* <div className="space-x-2">
            <button
              onClick={handleRetry}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            >
              Refresh Page
            </button>
          </div> */}
                </div>
            </div>
        );
    }

    if (!data) {
        return (
            <div className="tab-content flex justify-center items-center h-64">
                <p className="text-muted-foreground">No data available</p>
            </div>
        );
    }

    // Calculate total customers from dineInOrders + deliveryOrders
    const totalCustomers = (data.dineInOrders || 0) + (data.deliveryOrders || 0);
    const cards = [
        {
            title: "Total Revenue",
            value: data.totalRevenue || 0,
            prefix: "₹",
            icon: <FaRupeeSign />,
            iconColor: "#e66d33",
            bgColor: "#fbe4d5",
        },

        {
            title: "Today's Revenue",
            value: data.todayRevenue || 0,
            prefix: "₹",
            icon: <BiWallet />,
            iconColor: "#2563eb",
            bgColor: "#dbeafe",
        },

        {
            title: "Total Orders",
            value: data.totalOrders || 0,
            icon: <FaShoppingCart />,
            iconColor: "#9333ea",
            bgColor: "#f3e8ff",
        },

        {
            title: "Today's Orders",
            value: data.todayTotalOrders || 0,
            icon: <FaShoppingCart />,
            iconColor: "#16a34a",
            bgColor: "#dcfce7",
        },

        {
            title: "Sales Growth",
            value: data.salesGrowth || "0%",
            icon: <MdTrendingUp />,
            iconColor: "#16a34a",
            bgColor: "#dcfce7",
        },
    ];

    // Find peak hour from hourlyOrderBreakdown
    const peakHour = data.hourlyOrderBreakdown?.reduce((max, current) =>
        current.orders > max.orders ? current : max
        , { hour: '00:00', orders: 0 });


    // Add this before your return statement
    const maxOrdersValue = trendData?.dailyStats?.slice(-7).length
        ? Math.max(...trendData.dailyStats.slice(-7).map(d => d.orders), 1)
        : 100;

    // Add this before your return statement (after trendData is available)
    const maxRevenue = trendData?.dailyStats?.slice(-7).length
        ? Math.max(...trendData.dailyStats.slice(-7).map(d => d.revenue), 1)
        : 1000;


    return (
        <div className="tab-content space-y-6">


            {/* Metric Cards */}
            <div className="w-full">
                <div className="grid grid-cols-5 gap-4 w-full items-stretch" style={{
                    display: "grid",
                    gridTemplateColumns:
                        "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: "16px",
                    width: "100%",
                    alignItems: "stretch",
                }}>
                    {cards.map((card) => (
                        <MetricCard key={card.title} {...card} />
                    ))}
                </div>
            </div>
            {/* Kitchen Snapshot */}

            {/* Top Selling Items */}
            {data.topPerformingVendors &&
                data.topPerformingVendors.length > 0 && (

                    <div
                        className="dash-card p-5"
                        style={{
                            background: "#fff",
                            borderRadius: "16px",
                            boxShadow:
                                "0 2px 10px rgba(0,0,0,0.08)",
                        }}
                    >

                        <h3
                            className="font-semibold text-sm text-muted-foreground mb-4"
                            style={{
                                fontSize: "18px",
                                fontWeight: 700,
                                marginBottom: "20px",
                            }}
                        >
                            Top Performing Vendors
                        </h3>

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns:
                                    "1fr 350px",
                                gap: "24px",
                                alignItems: "center",
                            }}
                        >

                            {/* Vendor Cards */}
                            <div
                                className="grid grid-cols-1 md:grid-cols-2 gap-4"
                            >

                                {data.topPerformingVendors
                                    .slice(0, 5)
                                    .map((vendor, index) => (

                                        <div
                                            key={index}
                                            style={{
                                                background: "#f8fafc",
                                                padding: "18px",
                                                borderRadius: "14px",
                                                border: "1px solid #e5e7eb",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                gap: "20px",
                                                flexWrap: "wrap",
                                            }}
                                        >

                                            {/* LEFT SIDE */}
                                            <div>
                                                <div
                                                    style={{
                                                        fontWeight: 700,
                                                        fontSize: "18px",
                                                        color: "#111827",
                                                    }}
                                                >
                                                    Vendor ID:
                                                    {vendor.vendorId}
                                                </div>
                                            </div>

                                            {/* RIGHT SIDE */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "24px",
                                                    flexWrap: "wrap",
                                                }}
                                            >

                                                {/* Growth */}
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                            color: "#6b7280",
                                                            marginBottom: "4px",
                                                        }}
                                                    >
                                                        Growth
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: 700,
                                                            color: "#2563eb",
                                                        }}
                                                    >
                                                        {vendor.salesGrowth}
                                                    </div>
                                                </div>

                                                {/* Revenue */}
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                            color: "#6b7280",
                                                            marginBottom: "4px",
                                                        }}
                                                    >
                                                        Revenue
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: 700,
                                                            color: "#000",
                                                        }}
                                                    >
                                                        ₹{vendor.revenue}
                                                    </div>
                                                </div>

                                                {/* Share */}
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                            color: "#6b7280",
                                                            marginBottom: "4px",
                                                        }}
                                                    >
                                                        Share
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "16px",
                                                            fontWeight: 700,
                                                            color: "#16a34a",
                                                        }}
                                                    >
                                                        {vendor.percentage}
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    ))}
                            </div>

                            {/* Pie Chart */}
                            <div
                                style={{
                                    width: "100%",
                                    height: "320px",
                                }}
                            >

                                <ResponsiveContainer
                                    width="100%"
                                    height="100%"
                                >

                                    <PieChart>

                                        <Pie
                                            data={pieChartData}
                                            cx="50%"
                                            cy="50%"
                                            outerRadius={110}
                                            dataKey="value"
                                            label
                                        >

                                            {pieChartData.map(
                                                (
                                                    entry,
                                                    index
                                                ) => (

                                                    <Cell
                                                        key={`cell-${index}`}
                                                        fill={
                                                            COLORS[
                                                            index %
                                                            COLORS.length
                                                            ]
                                                        }
                                                    />
                                                )
                                            )}

                                        </Pie>

                                        <Tooltip />

                                        <Legend />

                                    </PieChart>

                                </ResponsiveContainer>

                            </div>

                        </div>

                    </div>
                )}



            <InsightsChartSection
                chartData={formatChartData()}
                loading={trendLoading}
            />


            <style>
                {`
  /* ===== RESPONSIVE FOR SCREENS BELOW 769px ===== */
@media (max-width: 768px) {
  
  /* Metric Cards Grid - 2 cards per row on mobile */
  .food-analysis-dashboard .grid.grid-cols-5 {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px !important;
  }
  
  /* Make metric cards full width in their grid cell */
  .food-analysis-dashboard .metric-card {
    width: 100% !important;
    padding: 12px !important;
  }
  
  /* Adjust metric card content for mobile */
  .food-analysis-dashboard .metric-card .flex.items-center.justify-between {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }
  
  /* Icon size adjustment */
  .food-analysis-dashboard .metric-card .rounded-full {
    width: 40px !important;
    height: 40px !important;
  }
  
  .food-analysis-dashboard .metric-card .rounded-full svg {
    width: 18px !important;
    height: 18px !important;
  }
  
  /* Value text size */
  .food-analysis-dashboard .metric-card .text-lg.font-bold {
    font-size: 1.25rem !important;
  }
  
  /* Title text size */
  .food-analysis-dashboard .metric-card .text-xs.text-muted-foreground {
    font-size: 0.7rem !important;
  }
  
  /* Top Selling Items Grid */
  .food-analysis-dashboard .grid.grid-cols-1.md\:grid-cols-5 {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px !important;
  }
  
  /* Top selling items cards */
  .food-analysis-dashboard .bg-gray-50.rounded-lg {
    padding: 10px !important;
  }
  
  .food-analysis-dashboard .bg-gray-50.rounded-lg .font-medium {
    font-size: 13px !important;
  }
  
  .food-analysis-dashboard .bg-gray-50.rounded-lg .text-muted-foreground.text-xs {
    font-size: 10px !important;
  }
  
  .food-analysis-dashboard .bg-gray-50.rounded-lg .text-primary.font-semibold {
    font-size: 12px !important;
  }
  
  /* Dash card padding */
  .food-analysis-dashboard .dash-card {
    padding: 12px !important;
  }
  
  .food-analysis-dashboard .dash-card h3 {
    font-size: 14px !important;
    margin-bottom: 12px !important;
  }
  
  /* Tab content area */
  .food-analysis-dashboard .tab-content {
    padding: 0 8px !important;
  }
  
  /* Loading and error states */
  .food-analysis-dashboard .tab-content.flex.justify-center.items-center.h-64 {
    height: auto !important;
    padding: 40px 20px !important;
  }
  
  /* Chart section adjustments */
  .food-analysis-dashboard .insights-chart-section {
    padding: 0 !important;
  }
  
  /* Make sure all containers use proper spacing */
  .food-analysis-dashboard .w-full.px-4.md\:px-6.lg\:px-8 {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  
  /* Space between sections */
  .food-analysis-dashboard .space-y-6 > * + * {
    margin-top: 16px !important;
  }
}

/* ===== EXTRA SMALL SCREENS (below 480px) ===== */
@media (max-width: 480px) {
  
  /* Keep 2 columns but reduce gap */
  .food-analysis-dashboard .grid.grid-cols-5 {
    gap: 8px !important;
  }
  
  /* Smaller metric cards */
  .food-analysis-dashboard .metric-card {
    padding: 10px !important;
  }
  
  .food-analysis-dashboard .metric-card .text-lg.font-bold {
    font-size: 1rem !important;
  }
  
  .food-analysis-dashboard .metric-card .rounded-full {
    width: 32px !important;
    height: 32px !important;
  }
  
  .food-analysis-dashboard .metric-card .rounded-full svg {
    width: 14px !important;
    height: 14px !important;
  }
  
  /* Top selling items - still 2 columns */
  .food-analysis-dashboard .grid.grid-cols-1.md\:grid-cols-5 {
    gap: 8px !important;
  }
  
  /* Even smaller text for top items */
  .food-analysis-dashboard .bg-gray-50.rounded-lg .font-medium {
    font-size: 12px !important;
  }
  
  .food-analysis-dashboard .bg-gray-50.rounded-lg .text-muted-foreground.text-xs {
    font-size: 9px !important;
  }
}

/* ===== TABLET LANDSCAPE (specific range) ===== */
@media (min-width: 500px) and (max-width: 768px) {
  /* Slightly larger cards on tablet */
  .food-analysis-dashboard .metric-card {
    padding: 14px !important;
  }
  
  .food-analysis-dashboard .metric-card .text-lg.font-bold {
    font-size: 1.3rem !important;
  }
}
  
  `}
            </style>



        </div>
    );
} export default FoodOverviewTab;